module.exports = __webpack_public_path__ + "static/img/lw_logo.15f793d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lw_logo.png
// module id = HtQc
// module chunks = 1